/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateAssetHistoryDto { 
    downloadedAsset: string;
    version: number;
    agency: string;
    variant: string;
    format: string;
    module: string;
    channel?: string;
    licenseRegion?: string;
}

